import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography, ToggleButton, ToggleButtonGroup, Box
} from '@mui/material';

export default function ModalFondosExternos({
  open, onClose,
  tipoFondo, setTipoFondo,
  montoFondo, setMontoFondo,
  descripcionFondo, setDescripcionFondo,
  metodoPago, setMetodoPago,
  onRegistrar,
}) {
  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold', bgcolor: '#00bcd4', color: '#fff' }}>
        💳 Movimiento de Fondos Externos
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Método de Pago:</Typography>
            <ToggleButtonGroup
              value={metodoPago}
              exclusive
              onChange={(e, newMetodo) => { if (newMetodo !== null) setMetodoPago(newMetodo); }}
              fullWidth
            >
              <ToggleButton value="EFECTIVO">💵 Efectivo</ToggleButton>
              <ToggleButton value="QR">📱 QR</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <FormControl fullWidth>
            <InputLabel>Tipo de Movimiento</InputLabel>
            <Select
              value={tipoFondo}
              onChange={(e) => setTipoFondo(e.target.value)}
              label="Tipo de Movimiento"
            >
              <MenuItem value="INGRESO">💰 Ingreso (Traer fondos)</MenuItem>
              <MenuItem value="RETIRO">🏧 Retiro (Quitar fondos)</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Monto"
            type="number"
            value={montoFondo}
            onChange={(e) => setMontoFondo(e.target.value)}
            fullWidth
            inputProps={{ step: '0.01', min: '0' }}
            helperText="Ingresa el monto a registrar"
          />

          <TextField
            label="Descripción (Opcional)"
            value={descripcionFondo}
            onChange={(e) => setDescripcionFondo(e.target.value)}
            fullWidth
            multiline
            rows={2}
            helperText={
              tipoFondo === 'INGRESO'
                ? 'Ej: Fondo inicial del propietario'
                : 'Ej: Retiro de ganancias'
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={onRegistrar}>
          Registrar Fondo
        </Button>
      </DialogActions>
    </Dialog>
  );
}
